// extracted by mini-css-extract-plugin
module.exports = {"notice":"notice__143Ao","title":"title__1rJCe","body":"body__qHP3W"};